import React from 'react';
import {
	FormattedMessage,
	defineMessages,
} from 'react-intl';

import Backlink from '~/components/logic/links/Backlink';
import ExportHeaderButton from '~/components/app/ExportHeaderButton';
import HeaderButtonsLayout from '~/components/atoms/screenLayouts/components/header/layouts/HeaderButtonsLayout';
import HeaderFilterLayout from '~/components/atoms/screenLayouts/components/header/layouts/HeaderFilterLayout';
import HeaderOptionsLayout from '~/components/atoms/screenLayouts/components/header/layouts/HeaderOptionsLayout';
import HeaderTitleLayout from '~/components/atoms/screenLayouts/components/header/layouts/HeaderTitleLayout';
import HeaderTitleWithNumericValue, {
	SIZE_SMALL as TITLE_SIZE_SMALL,
} from '~/components/atoms/screenLayouts/components/header/headerTitle/HeaderTitleWithNumericValue';
import ScreenHeader from '~/components/patterns/screens/basicScreen/header/ScreenHeader';
import SitemapsListActiveFilter from '~/components/app/SitemapsListActiveFilter';

import useExportSitemaps from '~/hooks/useExportSitemaps';
import useViewportType from '~/hooks/useViewportType';



const messages = defineMessages({
	export: {
		id: 'ui.general.export',
	},
	title: {
		id: 'ui.screen.sitemapsList.title',
	},
});



type Props = {
	activeFilterClickCallback: (filterProperty: string) => void,
	backlinkCallback?: () => void,
	backlinkLabel?: string,
	numberOfSitemaps: number,
};

const Header: React.FC<Props> = (props) => {
	const {
		activeFilterClickCallback,
		backlinkCallback,
		backlinkLabel,
		numberOfSitemaps,
	} = props;

	const exportSitemaps = useExportSitemaps();
	const viewportType = useViewportType();

	return (
		<ScreenHeader>
			<HeaderTitleLayout>
				{backlinkCallback && backlinkLabel && (
					<Backlink
						callback={backlinkCallback}
						label={backlinkLabel}
					/>
				)}

				<HeaderTitleWithNumericValue
					size={TITLE_SIZE_SMALL}
					title={(
						<FormattedMessage {...messages.title} />
					)}
					value={numberOfSitemaps}
				/>
			</HeaderTitleLayout>

			<HeaderFilterLayout compactView={viewportType.isSmall || viewportType.isMedium}>
				<SitemapsListActiveFilter
					onFilterClickCallback={activeFilterClickCallback}
				/>
			</HeaderFilterLayout>

			<HeaderOptionsLayout>
				<HeaderButtonsLayout>
					<ExportHeaderButton
						createExport={exportSitemaps}
						linkLabel={(
							<FormattedMessage {...messages.export} />
						)}
					/>
				</HeaderButtonsLayout>
			</HeaderOptionsLayout>
		</ScreenHeader>
	);
};



export default React.memo(Header);
